import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFileCertificate = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M15.714 0c.632 0 1.143.512 1.143 1.143v4.571h4.572a1.143 1.143 0 1 1 0 2.286h-4.572a2.286 2.286 0 0 1-2.285-2.286V1.143c0-.631.511-1.143 1.142-1.143Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M7.714 2.286a1.143 1.143 0 0 0-1.143 1.143v3.428a1.143 1.143 0 0 1-2.285 0V3.43A3.429 3.429 0 0 1 7.714 0h8c.303 0 .594.12.808.335l5.715 5.714c.214.214.335.505.335.808V19.43a3.429 3.429 0 0 1-3.43 3.428H13.43a1.143 1.143 0 0 1 0-2.286h5.714a1.143 1.143 0 0 0 1.143-1.143V7.332L15.24 2.286H7.714Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M3.339 10.482a4.571 4.571 0 1 1 6.465 6.465 4.571 4.571 0 0 1-6.465-6.465Zm3.232.947a2.286 2.286 0 1 0 0 4.571 2.286 2.286 0 0 0 0-4.571Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M5.186 16.048c.604.182.947.819.766 1.423l-.954 3.181 1.062-.531c.322-.161.7-.161 1.023 0l1.062.531-.954-3.18a1.143 1.143 0 1 1 2.19-.658l1.714 5.715a1.143 1.143 0 0 1-1.606 1.35L6.57 22.421l-2.917 1.458a1.143 1.143 0 0 1-1.606-1.35l1.715-5.715a1.143 1.143 0 0 1 1.423-.766Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFileCertificate);
export default ForwardRef;
